module.exports = __webpack_public_path__ + "static/media/colombo.3371a483.jpeg";